module.exports = __webpack_public_path__ + "static/4-6667e596790209f5b37655391d0d1163.png";